<template>
  <v-tooltip class="summary-tooltip" nudge-top="-20" nudge-left="150" color="#51515C" min-width="260" max-width="300"
    top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon @click="$emit('click')" class="text-primary--text cursor-pointer" :color="color" v-bind="attrs" v-on="on" rounded size="x-small" :icon="icon" />
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.summary-tooltip {
  background-color: var(--v-azul-medium-base) !important;
  color: white;
  max-width: 296px;
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  padding: 13px 9px;
}
</style>